import React from 'react';
import './nav.css';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/fontawesome-free-solid';

export default class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {visible: ""};
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick (e) {
    if (this.state.visible === "") {
      this.setState({visible: "visible"});
    } else {
      this.setState({visible: ""});
    }
  }

  handleClose (e) {
    if (this.state.visible === "visible") {
      this.setState({visible: ""});
    }
  }

  render () {
  return (
    <div className="nav-main">
      <div className="nav-name">
        <Link to={"/"}>Adam Schneit</Link>
      </div>
      <div className={`nav-menu ${this.state.visible}`}>
        <div className="bars-menu" onClick={this.handleClick}>
          <FontAwesomeIcon className="email-icon" icon={faBars} />
        </div>
        <ul className={`nav-links ${this.state.visible}`} onClick={this.handleClose}>
          <li className="nav-link-proj">
            <Link to={"/projects/songcabin"}>Projects</Link>
          </li>
          <li className="nav-link-skills">
            <Link to={"/skills"}>Skills</Link>
          </li>
          <li className="nav-link-contact">
            <Link to={"/contact"}>Contact</Link>
          </li>
        </ul>
      </div>
    </div>
  );
  }
}



// WEBPACK FOOTER //
// ./src/nav/nav.jsx